import styled from "styled-components";
import images from "../img";

function Home({ setPage }) {
    console.log(images);
    return (<HomeStyleWrapper className="home-container">
        <div className="title-container">
            <p className="description">
                라이프스타일을 담은<br />
                집을 만들고 싶은 당신을 위해
            </p>
            <p className="description bottom">
                <span className="emphasis">
                    <b>
                        나만의 인테리어 유형
                    </b>
                    을
                </span>
                찾아보세요
            </p>
            <button className="btn start-btn" onClick={() => {
                setPage("question");
            }}>
                START
            </button>
        </div>
    </HomeStyleWrapper>);
}

export default Home;

const HomeStyleWrapper = styled.div`
    position:relative;
    height: 100%;
    width:100%;
    background-image: url(${images['main_pc.jpg']});
    background-size:cover;
    background-position: center;
    display:flex;
    align-items:center;
    p{
        margin:0;
    }
    .title-container{
        max-width: 96.6rem;
        min-height: 48.6rem;
        padding:8rem;
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: rgba(255,255,255,0.5);
        margin:0 auto;
        box-sizing: border-box;
        text-align: center;
        .description{
            margin-bottom:1.3rem;
            &.bottom{
                margin-bottom:4rem;
            }
        }
        .emphasis{
            display: block;
            font-size: 5rem;
            margin-bottom: 0.5rem;
        }
        p{
            font-size:3.4rem;
            text-align: center;
            line-height: 1.32;
        }
        .start-btn{
            width: 28rem;
            background-color: #000;
            color:#fff;
            font-size: 2.4rem;
            padding:1.8rem;
            border: 0;
            border-radius: 999rem;
            cursor:pointer;
            &:hover{
                opacity: 0.8;
            }
        }
    }
    @media screen and (max-width:990px) {
        background-image: url(${images['main_m.jpg']});
        align-items:flex-start;
        .title-container{
            min-height:unset;
            background-color: unset;
            padding:0;
            padding-top:10rem;
            .emphasis{
                font-size: 3.2rem;
            }
            p{
                font-size:2.1rem;
            }
            .description.bottom{
                margin-bottom:3.45rem;
                &::after{
                    content:"";
                    width: 0px;
                    display: block;
                    margin: 2.85rem auto 0;
                    border: solid 1px #000;
                    height:50px;
                }
            }
        }
    }
`;